// import React, { useState } from "react";
// import "./formInput.css";

// function FormInputs(props) {
//   const [focused, setFocused] = useState(false);
//   const {
//     width,
//     padding,
//     height,
//     label,
//     errorMessage,
//     required,
//     onChange, 
//     icon,
//     bg,
//     ...inputProps
//   } = props;

//   const handleFocus = () => {
//     setFocused(true);
//   };

//   return (
//     <div className="formInput">
//       <label>
//         {label}
//         {required && <span>*</span>}
//       </label>
//       <input
//         {...inputProps}
//         onChange={onChange}
//         onBlur={handleFocus}
//         onFocus={handleFocus}
//         focused={focused.toString()}
//         style={{ height, padding, width, backgroundColor: bg}}
//       />
//     </div>
//   );
// }

// export default FormInputs;




// import React, { useState } from "react";
// import "./formInput.css";

// function FormInputs(props) {
//   const [focused, setFocused] = useState(false);
//   const {
//     width,
//     padding,
//     height,
//     label,
//     errorMessage,
//     required,
//     // onChange,
//     onChange = () => {},
//     icon,
//     bg,
//     disabled = false,
//     ...inputProps
//   } = props;

//   const handleFocus = () => {
//     setFocused(true);
//   };

//   const handleChange = (event) => {
//     const { value } = event.target;
//     // Validate the date input to ensure year is exactly 4 digits
//     if (inputProps.type === 'date') {
//       const datePattern = /^\d{4}-\d{2}-\d{2}$/;
//       const yearPattern = /^\d{4}$/;
//       const parts = value.split('-');

//       // Ensure year part has exactly 4 digits
//       if (parts.length === 3 && yearPattern.test(parts[0]) && datePattern.test(value)) {
//         onChange(event);
//       } else if (parts.length < 3) {
//         onChange(event); // Allow intermediate input for partial dates
//       }
//     } else {
//       onChange(event);
//     }
//   };

//   const currentYear = new Date().getFullYear();
//   const minYear = currentYear - 80;
//   const maxYear = currentYear - 10;

//   const maxYearHire = new Date(new Date().setMonth(new Date().getMonth() + 3)).toISOString().split("T")[0]


//   return (
//     <div className="formInput">
//       <label>
//         {label}
//         {required && <span>*</span>}
//       </label>
//       {/* <input
//         {...inputProps}
//         onChange={handleChange}
//         onBlur={handleFocus}
//         onFocus={handleFocus}
//         focused={focused.toString()}
//         style={{ height, padding, width, backgroundColor: bg }}
//         min={(inputProps.name === "hire_date")?`${currentYear-70}-01-01`:`${minYear}-01-01`}
//         max={(inputProps.name === "hire_date")?maxYearHire:`${maxYear}-12-31`}
//       /> */}
//       <input
//         {...inputProps}
//         disabled={disabled}
//         onChange={handleChange}
//         onBlur={handleFocus}
//         onFocus={handleFocus}
//         focused={focused.toString()}
//         className={props.className}
//         style={{ height, padding, width, backgroundColor: bg, cursor: disabled ? "not-allowed" : "text",  opacity: disabled ? 0.6 : 1 }}
//         min={inputProps.name === "hire_date" ? `${currentYear - 70}-01-01` : `${minYear}-01-01`}
//         max={inputProps.name === "hire_date" ? maxYearHire : `${maxYear}-12-31`}
//       />
//     </div>
//   );
// }

// export default FormInputs;











import React, { useState } from "react";
import "./formInput.css";

function FormInputs(props) {
  const [focused, setFocused] = useState(false);
  const {
    width,
    padding,
    height,
    label,
    errorMessage,
    required,
    onChange = () => {},
    icon,
    bg,
    disabled = false,
    showError = false, // NEW: prop to trigger error state
    ...inputProps
  } = props;

  const handleFocus = () => {
    setFocused(true);
  };

  const handleChange = (event) => {
    const { value } = event.target;
    // Validate the date input to ensure year is exactly 4 digits
    if (inputProps.type === 'date') {
      const datePattern = /^\d{4}-\d{2}-\d{2}$/;
      const yearPattern = /^\d{4}$/;
      const parts = value.split('-');

      // Ensure year part has exactly 4 digits
      if (parts.length === 3 && yearPattern.test(parts[0]) && datePattern.test(value)) {
        onChange(event);
      } else if (parts.length < 3) {
        onChange(event); // Allow intermediate input for partial dates
      }
    } else {
      onChange(event);
    }
  };

  const currentYear = new Date().getFullYear();
  const minYear = currentYear - 80;
  const maxYear = currentYear - 10;

  const maxYearHire = new Date(new Date().setMonth(new Date().getMonth() + 3)).toISOString().split("T")[0];

  // NEW: Determine if field should show error
  const hasError = showError && required && !inputProps.value;

  return (
    <div className="formInput">
      <label>
        {label}
        {required && <span>*</span>}
      </label>
      <input
        {...inputProps}
        disabled={disabled}
        onChange={handleChange}
        onBlur={handleFocus}
        onFocus={handleFocus}
        focused={focused.toString()}
        className={`${props.className || ''} ${hasError ? 'input-error' : ''}`}
        style={{ 
          height, 
          padding, 
          width, 
          backgroundColor: bg, 
          cursor: disabled ? "not-allowed" : "text",  
          opacity: disabled ? 0.6 : 1,
          border: hasError ? '1px solid #ff0000' : undefined // Red border on error
        }}
        // min={inputProps.name === "hire_date" ? `${currentYear - 70}-01-01` : `${minYear}-01-01`}
        // max={inputProps.name === "hire_date" ? maxYearHire : `${maxYear}-12-31`}
        min={ inputProps.min || (inputProps.name === "hire_date" ? `${currentYear - 70}-01-01` : `${minYear}-01-01`) }
        max={ inputProps.max || (inputProps.name === "hire_date" ? maxYearHire : `${maxYear}-12-31`) }
      />
      {/* {hasError && (
        <span className="error-text" style={{ color: '#ff0000', fontSize: '12px', marginTop: '4px' }}>
          This field is required
        </span>
      )} */}
    </div>
  );
}

export default FormInputs;
